const prefix = 'report/'

const type = {
    UPDATE_STATE: prefix + 'update_state',
    SET_INIT_STATE: prefix + 'set_init_state',

    // list report tab
    LOAD_LIST_REPORTS: prefix + 'load_list_reports',
    LOAD_LIST_REPORT_SUCCESS: prefix + 'load_list_report_success',
    USER_CHANGE_SELECT_TIER: prefix + 'user_change_select_tier',
    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_REPORT: prefix + 'search_report',
    UPDATE_TIME: prefix + 'update_time',
    UPDATE_PAGE_SIZE: prefix + 'update_page_size',
    UPDATE_PAGE_INDEX: prefix + 'update_page_index',

    // history tab
    LOAD_LIST_HISTORY_REPORTS: prefix + 'load_list_history_reports',
    LOAD_LIST_HISTORY_REPORTS_SUCCESS:
        prefix + 'load_list_history_reports_success',
    UPDATE_HISTORY_TEXT_SEARCH: prefix + 'update_history_text_search',
    SEARCH_HISTORY_REPORT: prefix + 'search_history_report',
    UPDATE_HISTORY_TIME: prefix + 'update_history_time',
    UPDATE_HISTORY_PAGE_SIZE: prefix + 'update_history_page_size',
    UPDATE_HISTORY_PAGE_INDEX: prefix + 'update_history_page_index',
    USER_CHANGE_HISTORY_SELECT_STATUS:
        prefix + 'user_change_history_select_status',

    // report info
    SET_CURRENT_REPORT: prefix + 'set_current_report',
    SET_DEFAULT_CURRENT_REPORT: prefix + 'set_default_current_report',
    UPDATE_CURRENT_REPORT: prefix + 'update_current_report',
    SAVE_CURRENT_REPORT: prefix + 'save_current_report',
    SHOW_MODAL_REPORT_INFO: prefix + 'show_modal_report_info',
    DISMISS_MODAL_REPORT_INFO: prefix + 'dismiss_modal_report_info',

    //hashtag
    ADD_HASH_TAG: prefix + 'add_hash_tag',
    DELETE_HASH_TAG: prefix + 'delete_hash_tag',

    // commnent
    ADD_COMMENT: prefix + 'add_comment',
    UPDATE_CURRENT_COMMENT: prefix + 'update_current_comment',

    // select media
    LOAD_LIST_SELECTED_MEDIA: prefix + 'load_list_selected_media',
    SHOW_MODAL_SELECT_MEDIA: prefix + 'show_modal_select_media',
    DISMISS_MODAL_SELECT_MEDIA: prefix + 'dismiss_modal_select_media',
    UPDATE_SELECTED_MEDIA: prefix + 'update_selected_media',

    // select object
    LOAD_LIST_SELECTED_OBJECT: prefix + 'load_list_selected_object',
    SHOW_MODAL_SELECT_OBJECT: prefix + 'show_modal_select_object',
    DISMISS_MODAL_SELECT_OBJECT: prefix + 'dismiss_modal_select_object',
    UPDATE_SELECTED_OBJECT: prefix + 'update_selected_object',

    // select event
    LOAD_LIST_SELECTED_EVENT: prefix + 'load_list_selected_event',
    SHOW_MODAL_SELECT_EVENT: prefix + 'show_modal_select_event',
    DISMISS_MODAL_SELECT_EVENT: prefix + 'dismiss_modal_select_event',
    UPDATE_SELECTED_EVENT: prefix + 'update_selected_event',

    // select report lower tier
    LOAD_LIST_SELECTED_REPORT: prefix + 'load_list_selected_report',
    SHOW_MODAL_SELECT_REPORT_LOWER_TIER:
        prefix + 'show_modal_select_report_lower_tier',
    DISMISS_MODAL_SELECT_REPORT_LOWER_TIER:
        prefix + 'dismiss_modal_select_report_lower_tier',
    UPDATE_SELECTED_REPORT_LOWER_TIER:
        prefix + 'update_selected_report_lower_tier',

    // send report
    SEND_CURRENT_REPORT: prefix + 'send_current_report',
    //
    GET_REPORT_BY_ID: prefix + 'get_report_by_id',
}

const action = {
    getReportById: id => {
        return {
            type: type.GET_REPORT_BY_ID,
            payload: {
                id,
            },
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    setInitState: () => {
        return {
            type: type.SET_INIT_STATE,
            payload: {},
        }
    },

    // list report tab
    loadListReport: params => {
        return {
            type: type.LOAD_LIST_REPORTS,
            payload: {
                params,
            },
        }
    },
    loadListReportSuccess: reports => {
        return {
            type: type.LOAD_LIST_REPORT_SUCCESS,
            payload: {
                reports,
            },
        }
    },
    userChangeSelectTier: tier => {
        return {
            type: type.USER_CHANGE_SELECT_TIER,
            payload: {
                tier,
            },
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch,
            },
        }
    },
    searchReport: () => {
        return {
            type: type.SEARCH_REPORT,
            payload: {},
        }
    },
    updateTime: (begin_time, end_time) => {
        return {
            type: type.UPDATE_TIME,
            payload: {
                begin_time,
                end_time,
            },
        }
    },
    updatePageSize: pageSize => {
        return {
            type: type.UPDATE_PAGE_SIZE,
            payload: {
                pageSize,
            },
        }
    },
    updatePageIndex: pageIndex => {
        return {
            type: type.UPDATE_PAGE_INDEX,
            payload: {
                pageIndex,
            },
        }
    },

    // history tab
    loadListHistoryReports: params => {
        return {
            type: type.LOAD_LIST_HISTORY_REPORTS,
            payload: {
                params,
            },
        }
    },
    loadListHistoryReportsSucess: history_reports => {
        return {
            type: type.LOAD_LIST_HISTORY_REPORTS_SUCCESS,
            payload: {
                history_reports,
            },
        }
    },
    updateHistoryTextSearch: textSearch => {
        return {
            type: type.UPDATE_HISTORY_TEXT_SEARCH,
            payload: {
                textSearch,
            },
        }
    },
    searchHistoryReport: () => {
        return {
            type: type.SEARCH_HISTORY_REPORT,
            payload: {},
        }
    },
    updateHistoryTime: (begin_time, end_time) => {
        return {
            type: type.UPDATE_HISTORY_TIME,
            payload: {
                begin_time,
                end_time,
            },
        }
    },
    updateHistoryPageSize: pageSize => {
        return {
            type: type.UPDATE_HISTORY_PAGE_SIZE,
            payload: {
                pageSize,
            },
        }
    },
    updateHistoryPageIndex: pageIndex => {
        return {
            type: type.UPDATE_HISTORY_PAGE_INDEX,
            payload: {
                pageIndex,
            },
        }
    },
    userChangeHistorySelectStatus: status => {
        return {
            type: type.USER_CHANGE_HISTORY_SELECT_STATUS,
            payload: {
                status,
            },
        }
    },

    // current report info
    setCurrentReport: report => {
        return {
            type: type.SET_CURRENT_REPORT,
            payload: {
                report,
            },
        }
    },
    setDefaultCurrentReport: userInfo => {
        return {
            type: type.SET_DEFAULT_CURRENT_REPORT,
            payload: {
                userInfo,
            },
        }
    },
    updateCurentReport: report => {
        return {
            type: type.UPDATE_CURRENT_REPORT,
            payload: {
                report,
            },
        }
    },
    saveCurrentReport: () => {
        return {
            type: type.SAVE_CURRENT_REPORT,
            payload: {},
        }
    },
    showModalReportInfo: () => {
        return {
            type: type.SHOW_MODAL_REPORT_INFO,
            payload: {},
        }
    },
    dismissModalReportInfo: () => {
        return {
            type: type.DISMISS_MODAL_REPORT_INFO,
            payload: {},
        }
    },

    // hashtag
    addHashTag: hashtag => {
        return {
            type: type.ADD_HASH_TAG,
            payload: {
                hashtag,
            },
        }
    },
    deleteHashTag: hashtag => {
        return {
            type: type.DELETE_HASH_TAG,
            payload: {
                hashtag,
            },
        }
    },

    // comment
    addComment: comment => {
        return {
            type: type.ADD_COMMENT,
            payload: {
                comment,
            },
        }
    },
    updateCurrentComment: comment => {
        return {
            type: type.UPDATE_CURRENT_COMMENT,
            payload: {
                comment,
            },
        }
    },

    // media modal
    loadListSelectedMedia: medias_id => {
        return {
            type: type.LOAD_LIST_SELECTED_MEDIA,
            payload: {
                medias_id,
            },
        }
    },
    showModalSelectMedia: () => {
        return {
            type: type.SHOW_MODAL_SELECT_MEDIA,
            payload: {},
        }
    },
    dismissModalSelectMedia: () => {
        return {
            type: type.DISMISS_MODAL_SELECT_MEDIA,
            payload: {},
        }
    },
    updateSelectedMedia: selected_Media => {
        return {
            type: type.UPDATE_SELECTED_MEDIA,
            payload: {
                selected_Media,
            },
        }
    },

    // objects modal
    loadListSelectedObject: objects_id => {
        return {
            type: type.LOAD_LIST_SELECTED_OBJECT,
            payload: {
                objects_id,
            },
        }
    },
    showModalSelectObject: () => {
        return {
            type: type.SHOW_MODAL_SELECT_OBJECT,
            payload: {},
        }
    },
    dismissModalSelectObject: () => {
        return {
            type: type.DISMISS_MODAL_SELECT_OBJECT,
            payload: {},
        }
    },
    updateSelectedObject: selected_object => {
        return {
            type: type.UPDATE_SELECTED_OBJECT,
            payload: {
                selected_object,
            },
        }
    },

    // Event modal
    loadListSelectedEvent: events_id => {
        return {
            type: type.LOAD_LIST_SELECTED_EVENT,
            payload: {
                events_id,
            },
        }
    },
    showModalSelectEvent: () => {
        return {
            type: type.SHOW_MODAL_SELECT_EVENT,
            payload: {},
        }
    },
    dismissModalSelectEvent: () => {
        return {
            type: type.DISMISS_MODAL_SELECT_EVENT,
            payload: {},
        }
    },
    updateSelectedEvent: selected_event => {
        return {
            type: type.UPDATE_SELECTED_EVENT,
            payload: {
                selected_event,
            },
        }
    },

    // report modal
    loadListSelectedReport: fid => {
        return {
            type: type.LOAD_LIST_SELECTED_REPORT,
            payload: {
                fid,
            },
        }
    },
    showModalSelectReportLowerTier: () => {
        return {
            type: type.SHOW_MODAL_SELECT_REPORT_LOWER_TIER,
            payload: {},
        }
    },
    dismissModalSelectReportLowerTier: () => {
        return {
            type: type.DISMISS_MODAL_SELECT_REPORT_LOWER_TIER,
            payload: {},
        }
    },
    updateSelectedReportLowerTier: selected_report => {
        return {
            type: type.UPDATE_SELECTED_REPORT_LOWER_TIER,
            payload: {
                selected_report,
            },
        }
    },
    sendCurrentReport: () => {
        return {
            type: type.SEND_CURRENT_REPORT,
            payload: {},
        }
    },
}

export default {
    type,
    action,
}
